export const generateIframeKey = (iframeUrl: string, iframeKey: number) =>
  `${iframeUrl}${iframeKey || ''}`;

export const generateIframeUrl = (
  customerSiteUrl: string,
  pathname: string,
  search: string,
  legacyPageSrc?: string,
  isNestedInNewPage?: boolean,
) => {
  const iframeUrl =
    legacyPageSrc == null
      ? `${customerSiteUrl}${pathname}${search}`
      : `${customerSiteUrl}/${legacyPageSrc}`;

  return iframeUrl.includes('?')
    ? `${iframeUrl}&legacypage=true${isNestedInNewPage ? '&nested-in-react-page=true' : ''}`
    : `${iframeUrl}?legacypage=true${isNestedInNewPage ? '&nested-in-react-page=true' : ''}`;
};

/**
 * Removes legacy iframe markers (legacypage and nested-in-react-page) from a URL string.
 * Handles edge cases where these are the only query params or mixed with other params.
 * Preserves URL hash fragments.
 */
export const cleanIframeMarkers = (url: string): string => {
  // Split URL into path, query string, and hash
  const questionMarkIndex = url.indexOf('?');
  if (questionMarkIndex === -1) {
    // No query string, return as-is
    return url;
  }

  const path = url.substring(0, questionMarkIndex);
  const afterPath = url.substring(questionMarkIndex + 1);

  // Split query string and hash
  const hashIndex = afterPath.indexOf('#');
  const queryString =
    hashIndex === -1 ? afterPath : afterPath.substring(0, hashIndex);
  const hash = hashIndex === -1 ? '' : afterPath.substring(hashIndex);

  // Parse query params
  const params = new URLSearchParams(queryString);

  // Remove the marker params
  params.delete('legacypage');
  params.delete('nested-in-react-page');

  // Rebuild URL
  const cleanedQueryString = params.toString();
  const query = cleanedQueryString ? `?${cleanedQueryString}` : '';
  return `${path}${query}${hash}`;
};
